import React from 'react';
import './skills.scss';
import SkillBars from '../SkillBars';

const context = {
    en: {
        label1: 'Programming languages, preprocessors',
        label2: 'Library, frameworks',
        label3: 'Tools',
        label4: 'Other',
        label5: 'Languages',
        label6: 'Data Bases',
    },
    ru: {
        label1: 'Языки программирования, препроцессоры',
        label2: 'Библиотеки, фреймворки',
        label3: 'Инструменты',
        label4: 'Дополнительно',
        label5: 'Языки',
        label6: 'Базы данных',
    },
};

const skills1 = [
    { type: 'HTML', level: 85 },
    { type: 'CSS', level: 86 },
    { type: 'JavaScript', level: 82 },
    { type: 'TypeScript', level: 87 },
    { type: 'SCSS', level: 80 },
];

const skills2 = [
    { type: 'Devextreme', level: 70 },
    { type: 'React', level: 60 },
    { type: 'Angular', level: 80 },
    { type: 'RxJs', level: 60 },
    { type: 'MaterialUI', level: 60 },
    { type: 'ExpressJS', level: 35 },
];
const skills3 = [
    { type: 'VS Code', level: 95 },
    { type: 'Git', level: 70 },
];
const skills4 = [
    { type: 'Windows', level: 80 },
    { type: 'Linux', level: 80 },
];
const skills5 = {
    en: [
        { type: 'Russian', level: 95 },
        { type: 'English', level: 50 },
    ],
    ru: [
        { type: 'Русский', level: 95 },
        { type: 'Английский', level: 50 },
    ],
};
const skills6 = [
    { type: 'MySQL', level: 30 },
    { type: 'PostgreSQL', level: 35 },
    { type: 'MongoDB', level: 30 },
];

const Skills = ({ lang }) => {
    const { label1, label2, label3, label4, label5, label6 } = context[lang];
    const skills = skills5[lang];
    return (
        <div className='Skills'>
            <div className='skillBlock'>
                <h5>{label1}</h5>
                <SkillBars skills={skills1} />
            </div>
            <div className='skillBlock'>
                <h5>{label2}</h5>
                <SkillBars skills={skills2} />
            </div>
            <div className='skillBlock'>
                <h5>{label4}</h5>
                <SkillBars skills={skills4} />
            </div>
            <div className='skillBlock'>
                <h5>{label5}</h5>
                <SkillBars skills={skills} />
            </div>
            <div className='skillBlock'>
                <h5>{label3}</h5>
                <SkillBars skills={skills3} />
            </div>
            <div className='skillBlock'>
                <h5>{label6}</h5>
                <SkillBars skills={skills6} />
            </div>
        </div>
    );
};

export default Skills;
